import { apiClient } from '../client.js';

/**
 * Payment Service
 * Handles payment operations using Laravel API
 */
export class PaymentService {
  constructor() {
    this.client = apiClient;
  }

  /**
   * Create payment intent
   */
  async createPaymentIntent(bookingId, amount, currency = 'EUR') {
    return this.client.post('/api/payments/intent', {
      booking_id: bookingId,
      amount,
      currency
    });
  }

  /**
   * Process payment
   */
  async processPayment(paymentData) {
    return this.client.post('/api/payments/process', paymentData);
  }

  /**
   * Confirm payment
   */
  async confirmPayment(paymentId) {
    return this.client.post(`/api/payments/${paymentId}/confirm`);
  }

  /**
   * Refund payment
   */
  async refundPayment(paymentId, amount = null, reason = null) {
    return this.client.post(`/api/payments/${paymentId}/refund`, {
      amount,
      reason
    });
  }

  /**
   * Get payment status
   */
  async getPaymentStatus(paymentId) {
    return this.client.get(`/api/payments/${paymentId}/status`);
  }

  /**
   * Get payment methods
   */
  async getPaymentMethods() {
    return this.client.get('/api/payments/methods');
  }

  /**
   * Calculate payment fees
   */
  async calculateFees(amount, method) {
    return this.client.post('/api/payments/calculate-fees', {
      amount,
      method
    });
  }
} 